module.exports = {"420902001":"孝南区书院街","420902002":"孝南区新华街","420902003":"孝南区广场街","420902004":"孝南区车站街道","420902100":"孝南区新铺镇","420902101":"孝南区西河镇","420902102":"孝南区杨店镇","420902103":"孝南区陡岗镇","420902104":"孝南区肖港镇","420902105":"孝南区毛陈镇","420902106":"孝南区三汊镇","420902107":"孝南区祝站镇","420902200":"孝南区朋兴乡","420902201":"孝南区卧龙乡","420902202":"孝南区闵集乡","420902400":"孝南区经济开发区","420902450":"孝南区朱湖","420902500":"孝南区东山头","420902570":"孝感开发区丹阳","420902571":"孝感开发区孝天","420902572":"孝感开发区槐荫"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420902.json
// module id = 1606
// module chunks = 0